import {connect, useSelector} from "react-redux";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CInputGroup,
    CInputGroupText, CModal, CModalBody,
    CModalHeader, CModalTitle,
    CRow
} from "@coreui/react";
import {AgGridReact} from "ag-grid-react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {useNavigate} from "react-router-dom";
import {Loading} from "../../../components/common";
import StoreListWhere from "../where/StoreListWhere";
import * as api from "../../../api/api";
import {currencyFormatter} from "../../../config/formatter";
import ProductDetail from "./ProductDetail";
import "src/scss/grid-styles.scss";
import axios from "axios";

const ProductRegister = (props) => {
    const {user} = useSelector((props) => props.account);
    const defaultProduct = {
        cmpCd: user.cmpCd,
         brandCd: user.brandCd,
        //brandCd: "1000",
        productCd: "", barcode: "", productNm: "", productDiv: "1", productStatus: '1', sourceCd: "", price: 0, subPrice: 0, bagYn: 'N', bagPrice: 0, unit: '1',
        taxYn: 'Y', stockYn: 'Y', useYn: 'Y', dcYn: 'N', stockType: "1", soldoutYn: 'N', etc1:""
    }
    const [searchForm, setSearchForm] = useState({});
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({visible: false, message: ""});
    const [selectProduct, setSelectProduct] = useState({});
    const [registerType, setRegisterType] = useState("R");
    const [copyImageUrl, setCopyImageUrl] = useState("");

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: 'barcode', headerName: '상품코드', width: 130},
        {field: 'productNm', headerName: '상품명'},
        {field: 'sourceCd', headerName: '바코드', width: 200},
        {field: 'supPrice', headerName: '원가', width: 60, valueFormatter: currencyFormatter},
        {field: 'price', headerName: '판매가', width: 70, valueFormatter: currencyFormatter},
        {field: 'bagYn', headerName: '봉투사용여부', width: 120},
        {field: 'bagPrice', headerName: '봉투금액', width: 80},
        {field: 'updTime', headerName: '등록일자', width: 150}
    ])

    const info = () => {
        console.log(">>>>>> 신규등록");
        setRegisterType("N");
        setSelectProduct(defaultProduct);
    };

    const onImageUpload = (e) => {
        if (selectProduct.productCd === '') {
            Alert.alert("상품을 먼저 선택해주세요.");
            return;
        }

        if (!e.target.files) {
            return;
        }

        onImageUploadCopy(e);

        setLoading(true);

        const formData = new FormData();
        formData.append('image', e.target.files[0]);
        formData.append('productCd', selectProduct.productCd)

        axios({
            baseURL: process.env.REACT_APP_API_URL,
            url: '/product/ckpos/product/image',
            method: 'POST',
            data: formData,
        })
            .then(response => {
                console.log(">>> response :: ", response);
                const { responseBody } = response.data;
                const host = process.env.REACT_APP_IMAGE_HOST;

                setSelectProduct((state) => ({
                    ...state,
                    imgPath: host + responseBody.resourceUrl
                }))
            })
            .finally(() => {
                // 복사 프로세스 처리
                onImageUploadCopy(e);
            })
    }

    const onImageUploadCopy = (e) => {
        // 상품코드 찾기
        const params = {
            cmpCd: "0013",
            restProductCd: selectProduct.restProductCd
        }
        console.log(">>> params :: ", params);
        api.getProductByRestProductCd(params).then((result) => {
            const {responseBody, responseCode} = result.data;
            if (responseCode === "200") {
                if (responseBody) {
                    const formData = new FormData();
                    formData.append('image', e.target.files[0]);
                    formData.append('productCd', responseBody.productCd)

                    axios({
                        baseURL: process.env.REACT_APP_API_URL,
                        url: '/product/ckpos/product/image',
                        method: 'POST',
                        data: formData,
                    })
                        .then(response => {
                            console.log(">>> response :: ", response);
                            const { responseBody } = response.data;
                            const host = process.env.REACT_APP_IMAGE_HOST;

                            setCopyImageUrl(host + responseBody.resourceUrl);

                        })
                        .finally(() => {
                            setLoading(false);
                        })
                }
            }
        })
    }

    const save = async () => {
        setError({visible: false, message: ""});
        if (selectProduct.barcode === "") {
            alert("상품을 먼저 선택하시거나 신규 등록해주세요.");
            return;
        }

        if (confirm("저장하시겠습니까?")) {
            // 상품코드 중복 체크
            const params = {
                cmpCd: "0012",
                restProductCd: selectProduct.barcode
            }

            setLoading(true);
            api.getProductByRestProductCd(params).then((result) => {
                const { responseBody, responseCode } = result.data;
                if (responseCode === "200") {
                    console.log(">>> response :: ", responseBody);
                    if (responseBody) {
                        if (selectProduct.productCd !== responseBody.productCd) {
                            setLoading(false);
                            alert("이전에 등록된 상품코드 입니다. 다른 코드로 등록 해주세요.");
                            return;
                        }
                    }

                    const product = {
                        ...selectProduct,
                        cmpCd: selectProduct.cmpCd ? selectProduct.cmpCd : "0012",
                        brandCd: selectProduct.brandCd ? selectProduct.brandCd : "",
                        imgYn: "Y",
                        //sourceCd: selectProduct.sourceCd.replaceAll(selectProduct.barcode, ""),
                        instUser: selectProduct.instUser ? selectProduct.instUser : user.userId,
                        etc_1 : selectProduct.etc1,
                        updUser: user.userId,
                    }
                    delete product.instTime;
                    delete product.updTime;
                    if(product.productCd !== "") {
                        //console.log(">>> product.productCd :: ", product.productCd);
                        product.sourceCd = "";
                    }
                    console.log(">>>저장 request :: ", product);

                    api.putProduct(product).then((result) => {
                        const {responseBody, responseCode, responseMessage} = result.data;
                        console.log(">>> result :: ", result);
                        if (responseCode === "200") {
                            // 성공
                            alert("정상적으로 처리되었습니다.");
                            search();
                        } else {
                            setError({visible: true, message: responseMessage});
                        }
                    })
                        .catch((e) => {
                            setError({visible: true, message: e.message});
                        })
                        .finally(() => {
                            setLoading(false);
                        })
                }
            })
        }
    }

    const search = async () => {
        setError({visible: false, message: ""});
        setSelectProduct(defaultProduct);

        const params = {
            cmpCd: !user.cmpCd ? "0012" : user.cmpCd,
            // brandCd: user.brandCd,
            // storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode
        };
        console.log(">>> params :: ", params);

        setLoading(true);
        try {
            const {data: result} = await api.getProductListByAll(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setRowData(responseBody);
            } else {

            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    };

    const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), []);
    const gridStyle = useMemo(() => ({height: 550, width: '100%'}), []);

    const onRowSelected = useCallback((event) => {
        if (!event.node.selected)
            return;
        setSelectProduct();
        setSelectProduct(event.node.data);
        setRegisterType("E");
        // setModal({visible: true});
    }, []);

    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>상품 등록/조회</h5>
                <div>
                    <CButton style={{marginRight: 10}} color="dark" onClick={info}>신규</CButton>
                    <CButton style={{marginRight: 10}} color="dark" onClick={save}>저장</CButton>
                    <CButton color="dark" onClick={search}>조회</CButton>
                </div>
            </div>
            <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>상품코드</CInputGroupText>
                        <CFormInput id="productCd"
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            search();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            restProductCd: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>상품명</CInputGroupText>
                        <CFormInput id="productNm"
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            search();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            productNm: e.target.value
                                        }));
                                    }}
                        />
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>바코드</CInputGroupText>
                        <CFormInput id="barcode"
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            search();
                                        }
                                    }}
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            barcode: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
            </CForm>

            <div style={{height: 10}}/>
            <CRow>
                <CCol md={3}>
                    <div className="ag-theme-alpine" style={gridStyle}>
                        <AgGridReact
                          rowSelection={'single'}
                          headerHeight={30}
                          rowHeight={30}
                          onRowSelected={onRowSelected}
                          rowData={rowData}
                          columnDefs={columnDefs}>
                        </AgGridReact>
                    </div>
                </CCol>
                <CCol md={9}>
                    <ProductDetail data={selectProduct} openType={registerType} handler={setSelectProduct} onImageUpload={onImageUpload}/>
                </CCol>
            </CRow>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductRegister);
